// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: false,
        styleScrollToTop: 'style2',
      	showLimitList: '12, 20, 32, 40',
    },
};

var bcSfFilterTemplate = {
    'soldOutClass': 'product-price--sold-out grid-view-item--sold-out',
 
    // Grid Template
    'vendorGridHtml': '<div class="grid-view-item__vendor">{{itemVendorLabel}}</div>',
    'soldOutLabelGridHtml': ' <span class="product-price__sold-out">' + bcSfFilterConfig.label.sold_out + '</span>',
    'productGridItemHtml': '<div class="hd grid__item {{itemGridWidthClass}}">' +
  								'<div data-video="{{itemVideo}}" class="video-player grid-view-item {{itemSoldOutClass}}">' +
                                    '<a class="grid-view-item__link" href="{{itemUrl}}">' +
                                        '{{imageStyle}}' +
                                        '{{itemImages}}' +
                                        '{{itemSwatches}}' +
                                        '<div class="h5 grid-view-item__title text-center">{{itemCustomTitle}}</div>' +
                                    '</a>' +
                                '</div>' +
                            '</div>',

    // List Template
    'vendorSmallListHtml': '<div class="list-view-item__vendor-column small--hide"><div class="list-view-item__vendor">{{itemVendorLabel}}</div></div>',
    'vendorMediumListHtml': '<div class="list-view-item__vendor medium-up--hide">{{itemVendorLabel}}</div>',
    'saleLabelListHtml': '<div class="list-view-item__on-sale">' + bcSfFilterConfig.label.sale + '</div>',
    'soldOutLabelListHtml': '<div class="list-view-item__sold-out">' + bcSfFilterConfig.label.sold_out + '</div>',
    'productListItemHtml':  '<a href="{{itemUrl}}" class="list-view-item">' +
                                '<div class="list-view-item__image-column">' +
                                    '<div class="list-view-item__image-wrapper">' +
                                        '<img class="list-view-item__image" src="{{itemThumbUrl}}" alt="">' +
                                    '</div>' +
                                '</div>' +
                                '<div class="list-view-item__title-column">' +
                                    '<div class="list-view-item__title">{{itemTitle}}</div>' +
                                    '{{itemSaleLabel}}' +
                                    '{{itemMediumVendor}}' +
                                    '{{itemSoldOutLabel}}' +
                                '</div>' +
                                '{{itemSmallVendor}}' +
                                '<div class="list-view-item__price-column">{{itemPrice}}</div>' +
                            '</a>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></a></li>',
    'previousDisabledHtml': '<li><div class="btn btn--secondary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></div></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Next</span></a></li>',
    'nextDisabledHtml': '<li><div class="btn btn--secondary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Next</span></div></li>',
    'pageItemHtml': '<a href="{{itemUrl}}"><span class="page">{{itemTitle}}</span></a>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
  	'paginateHtml': '<ul class="list--inline pagination clearfix">{{previous}}<li class="pagination__text">{{pageItems}}</li>{{next}}</ul>',
  
    // Sorting Template
    'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="filters-toolbar__input filters-toolbar__input--sort">{{sortingItems}}</select>',
	
  	// Show Limit Template
    'showLimitHtml': '<label class="collection-sort__label">View</label><select class="collection-sort__input">{{showLimitItems}}</select>',
};


BCSfFilter.prototype.buildProductGridItem = function(data) {
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/
  
    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add a specific class for grid item
    var itemGridWidthClass = '';
    var imageSize = '600x600';
    switch(bcSfFilterConfig.custom.products_per_row) {
        case 2:
            itemGridWidthClass = 'medium-up--one-half';
            imageSize = '540x600';
            break;
        case 3:
            itemGridWidthClass = 'small--one-half medium-up--one-third';
            imageSize = '345x550';
            break;
        case 4:
            itemGridWidthClass = 'small--one-half medium-up--one-quarter';
            imageSize = '250x';
            break;
        case 5:
            itemGridWidthClass = 'small--one-half medium-up--one-fifth';
            imageSize = '195x';
            break;
    }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelGridHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    var img_id = 'ProductCardImage-{{itemId}}';
    var wrapper_id = 'ProductCardImageWrapper-{{itemId}}';

    // Build Image style
    var imageStyle = buildImageStyle(data);
    itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

    // Add Images
    var aspect_ratio = '';
  	var hoverImage = '';
  	
  	var product_video_metafields = this.getProductMetafield(data, 'product_video', 'video_link') || '';
  
  	console.log("Metafields video link:- "+product_video_metafields);
  
    if (images.length > 1) {
		hoverImage = images[1]['src'];
    }
    var itemImagesHtml = '<div id="' + wrapper_id + '" class="grid-view-item__image-wrapper js">';
    itemImagesHtml += '<div style="padding-top:';
    if (images.length > 0) {
        aspect_ratio = images[0]['width'] / images[0]['height'];
        itemImagesHtml += 1 / aspect_ratio * 100;
    } else {
        itemImagesHtml += 100;
    }
    itemImagesHtml += '%;">';
    itemImagesHtml += '<img id="' + img_id + '" ' +
                        'class="grid-view-item__image lazyload" ' +
                        'src="' + this.getFeaturedImage(images, '300x300') + '" ' +
                        // 'data-src="' + this.getFeaturedImage(images, '{width}x') + '" ' +
                        'data-src="' + this.getFeaturedImage(images) + '" ' +
                        'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                        'data-aspectratio="' + aspect_ratio + '" ' +
                        'data-sizes="auto" ' +
                        'alt="{{itemTitle}}">';
    itemImagesHtml += '<img class="collection-hover_img" src="' + hoverImage + '">';
  	itemImagesHtml +='<div class="grid-view-item__video-preloader">';
  	itemImagesHtml +='</div>';
    itemImagesHtml += '</div>';
    itemImagesHtml += '</div>';

    var image_size = bcSfFilterConfig.custom.max_height + 'x' + bcSfFilterConfig.custom.max_height;
    var max_width = images.length > 0 ? bcSfFilterConfig.custom.max_height * aspect_ratio : 0;
    itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + this.getFeaturedImage(images, image_size + '@2x') + '" alt="" style="max-width: ' + max_width + 'px;"></noscript>';
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
  
  	// Add Item video
    // itemHtml = itemHtml.replace(/{{itemVideo}}/g, product_video_metafields);
  	itemHtml = itemHtml.replace(/{{itemVideo}}/g, '');

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorGridHtml : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    //var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, '');

    // Add Title
  	var topprice = this.getProductMetafield(data, 'product', 'topprice') || '';
  	topprice = (topprice) ? bcsffilter.formatMoney(topprice * 100, bcsffilter.moneyFormat) : '';
  
  	var toppricesale = this.getProductMetafield(data, 'product', 'toppricesale') || '';
  	toppricesale = (toppricesale) ? bcsffilter.formatMoney(toppricesale * 100, bcsffilter.moneyFormat) : '';
  
  	var bottomprice = this.getProductMetafield(data, 'product', 'bottomprice') || '';
  	bottomprice = (bottomprice) ? bcsffilter.formatMoney(bottomprice * 100, bcsffilter.moneyFormat) : '';
  
  	var bottompricesale = this.getProductMetafield(data, 'product', 'bottompricesale') || '';
  	bottompricesale = (bottompricesale) ? bcsffilter.formatMoney(bottompricesale * 100, bcsffilter.moneyFormat) : '';

    //var mainTitle = data.title.split('•')[0].split('-')[1].split('&');
  	var prodTitle = data.title.split('-');
    if (prodTitle.length > 1) {
      prodTitle = prodTitle[1].split('•');
      prodTitle = prodTitle[0].split('&');
    } else {
      prodTitle = prodTitle[0].split('•');
      prodTitle = prodTitle[0].split('&'); 
    }
    
  	var itemCustomTitle = '';
    if (toppricesale == '') {
		itemCustomTitle += prodTitle[0] + ' '+ ' <span class="money">' + topprice + '</span> <BR/>';
    } else {
      	itemCustomTitle += prodTitle[0] + ' ' + '<span style="text-decoration: line-through;"><span class=money>' + topprice + '</span></span><span style="color:#a31313"><BR/>Sale: <span class="money">' + toppricesale + '</span></span> <BR/>';
	}
    
  	if(data.product_type == 'Master' && prodTitle.length > 1){
     // console.log(bottomprice);
      	if (bottompricesale == ''){
            itemCustomTitle += prodTitle[1] + ' '+ ' <span class="money">' + bottomprice + '</span>';
        } else {
            itemCustomTitle += prodTitle[1] + ' ' + ' <span style="text-decoration: line-through;"><span class=money>' + bottomprice + '</span></span><span style="color:#a31313"><BR/>Sale: <span class="money">' + bottompricesale + '</span></span>';
        }
    }
    
    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  	itemHtml = itemHtml.replace(/{{itemCustomTitle}}/g, itemCustomTitle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  
  	console.log('get swatch ', data);
  
    var swatchHtml = this.getProductMetafield(data, 'lulifama', 'lfswatch') || "";
    
    itemHtml = itemHtml.replace(/{{itemSwatches}}/g, swatchHtml);

    return itemHtml;
}

// Build Image style
function buildImageStyle(data) {
    var images = data.images_info;
    var img_id = 'ProductCardImage-{{itemId}}';
    var wrapper_id = 'ProductCardImageWrapper-{{itemId}}';
    var imageStyle = '';
    if (images.length > 0) {
        var image = images[0];
        var width = bcSfFilterConfig.custom.max_height;
        var height = bcSfFilterConfig.custom.max_height;
        var aspect_ratio = image.width / image.height;
        var small_style = true;
        var container_aspect_ratio = width * 1.0 / height;

        if (image.aspect_ratio < 1.0) {
            var maximum_width = height * aspect_ratio;
            if (image.height <= height) {
                var maximum_height = image.height;
                maximum_width = image.width;
            } else {
                var maximum_height = height;
            }
        } else if (aspect_ratio < container_aspect_ratio) {
            var maximum_height = height / aspect_ratio;
            if (image.height <= height) {
                var maximum_height = image.height;
                var maximum_width = image.width;
            } else {
                var maximum_height = height;
                var maximum_width = height * aspect_ratio;
            }
        } else {
            var maximum_height = height / aspect_ratio;
            if (image.width <= width) {
                maximum_height = image.height;
                var maximum_width = image.width
            } else {
                var maximum_width = width;
                maximum_height = maximum_width / aspect_ratio;
            }
        }

        imageStyle += '<style>';
        if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
        imageStyle +=   '#' + img_id + ' {' +
                            'max-width: ' + maximum_width + 'px;' +
                            'max-height: ' + maximum_height + 'px;' +
                        '}' +
                        '#' + wrapper_id + ' {' +
                            'max-width: ' + maximum_width + 'px;' +
                            'max-height: ' + maximum_height + 'px;' +
                        '}';
        if (small_style) imageStyle += '}';
  
        if (small_style) {
            if (aspect_ratio < 1) {
                maximum_width = 750 * aspect_ratio;
            } else {
                if (image.width < 750) {
                    maximum_width = image.width;
                } else {
                    maximum_width = 750;
                }
            }
            imageStyle += '@media screen and (max-width: 749px) {'
            imageStyle +=   '#' + img_id + ' {' +
                                'max-width: ' + maximum_width + 'px;' +
                                'max-height: 750px;' +
                            '}' +
                            '#' + wrapper_id + ' {' +
                                'max-width: ' + maximum_width + 'px;' +
                            '}';
            imageStyle += '}';
        }
        imageStyle += '</style>';
    }
    return imageStyle;
}

BCSfFilter.prototype.buildProductListItem = function(data) {
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productListItemHtml;

    // Add onSale label
    var itemSaleLabel = onSale ? bcSfFilterTemplate.saleLabelListHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelListHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '600x600') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Vendor
    var itemSmallVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorSmallListHtml : '';
    itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
    var itemMediumVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorMediumListHtml : '';
    itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

    // Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data, false));

    return itemHtml;
}

function buildPrice(data, onSale, priceVaries) {
    var priceHtml = '';
    if (onSale) {
        if (priceVaries) {
            priceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
            priceHtml += '<s class="product-price__price">' + bcsffilter.formatMoney(data.compare_at_price_min, bcsffilter.moneyFormat) +'</s>';
            priceHtml += ' <span class="product-price__price product-price__sale">';
            priceHtml += '<span class="product__price">' + bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat) + '</span>';
            priceHtml += ' <span class="product-price__sale-label">' + bcSfFilterConfig.label.sale + '</span>';
            priceHtml += '</span>';
        } else {
            priceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
            priceHtml += '<s class="product-price__price">' + bcsffilter.formatMoney(data.compare_at_price_min, bcsffilter.moneyFormat) + '</s>';
            priceHtml += ' <span class="product-price__price product-price__sale">';
            priceHtml += bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
            priceHtml += ' <span class="product-price__sale-label">' + bcSfFilterConfig.label.sale + '</span>';
            priceHtml += '</span>';
        }
    } else {
        if (priceVaries) {
            priceHtml += '<span class="product__price">' + bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat) + '</span>';
        } else {
            priceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
            priceHtml += '<span class="product-price__price">' + bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat) + '</span>';
        }
    }
    return priceHtml;
}

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Featured image
        if (data['images_info'] > 0) {
            data[k]['featured_image'] = data['images_info'][0];
        } else {
            data[k]['featured_image'] = {width: '', height: '', aspect_ratio: 0}
        }

        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};


// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
    var itemHtml = '<span>View As </span>';
    itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid bc-sf-filter-sprite" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
    itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list bc-sf-filter-sprite" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
    jQ(this.selector.topDisplayType).html(itemHtml);

    // Active current display type
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
    if (this.queryParams.display == 'list') {
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
    } else if (this.queryParams.display == 'grid') {
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    jQ('#bc-sf-filter-products').removeClass();
    if (this.queryParams.display == 'list') {
        jQ('#bc-sf-filter-products').addClass('list-view-items');
    } else {
        jQ('#bc-sf-filter-products').addClass('grid grid--uniform grid--view-items');
    }
};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();
	/* Start Initialize BC QuickView */
// 	if (typeof(bcQuickView) !== 'undefined') {
// 		if(typeof(bcQuickViewParams) !== 'undefined') {
// 			bcQuickView.init(bcQuickViewParams);
// 		} else {
// 			bcQuickView.init();
// 		}
// 	}
	/* End Initialize BC QuickView */
  
 	var self = this;
    if(typeof SECOMAPP != 'undefined' && typeof SECOMAPP.pl != 'undefined' && typeof SECOMAPP.pl.labelCollections == 'function'){
        SECOMAPP.pl.pisRegex = self.getSelector('products') + ' .grid-view-item__link';
        SECOMAPP.pl.labelCollections(true);    
    }

    var totalProduct = '';
    if (data.total_product == 1) {
        totalProduct = bcSfFilterConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
    } else {
        totalProduct = bcSfFilterConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
    }
    jQ('#bc-sf-filter-total-product').html(totalProduct);
  
    jQ(".video-player").on("mouseover tap touchstart", function(){
		var videoSource = jQ(this).attr("data-video");
      	var htmlVideo = "";
      	htmlVideo += '<video autoplay loop muted playsinline oncontextmenu class="video-test">';
  		htmlVideo += '<source data-src="' + videoSource + '" type="video/mp4" src="' + videoSource + '">';
  		htmlVideo += '</video>';
        if(jQ(this).find(".grid-view-item__video-preloader").is(':empty')){
          jQ(this).find(".grid-view-item__video-preloader").html(htmlVideo);
        }
    });
  
    console.log('swatch theme');
  
    jQ('a.grid-view-item__link').each(function() {
      
      var wrapper = this;
      var mainImage = jQ('img.grid-view-item__image', wrapper)[0];
      var backImage = jQ('img.collection-hover_img', wrapper)[0];
      var anchor = jQ('a.grid-view-item__link', wrapper)[0];
      
      var changeImage = function(e) {
        e.preventDefault();
          
        jQ(mainImage).attr('src', this.dataset.frontimg)
         			.attr('srcset', '')
        			.attr('data-srcset', '');
        jQ(backImage).attr('src', this.dataset.backimg);
        
        jQ(wrapper).attr('href', '/products/' + this.dataset.url);
      }
      
      jQ('.swatches-dt img', wrapper).hover(changeImage);
      jQ('.swatches-mob img', wrapper).click(changeImage);
      
    });
}

// Prepare Search params
BCSfFilter.prototype.prepareSearchParams = function(params, eventType) {
    if (this.isSearchPage()) {
        params['q'] = this.getSearchTerm();
      	params.product_type = 'Master';
        if (this.searchTermKey != 'q') delete params[this.searchTermKey];
        if (!this.getSettingValue('search.enableFuzzy')) params.fuzzy = false;
    }
    return params;
};

BCSfFilter.prototype.buildFilterShowLimit = function() {
	if (bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
        jQ(this.selector.topShowLimit).html('');

        var numberList = this.getSettingValue('general.showLimitList');
        if (numberList != '') {
            // Build content
            var showLimitItemsHtml = '';
            var arr = numberList.split(',');
            for (var k = 0; k < arr.length; k++) {
                var label = arr[k];
                if (arr[k] == 50) label = 'All';
                showLimitItemsHtml += '<option value="' + arr[k].trim() +'">' + label + '</option>';
            }
            var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
            jQ(this.selector.topShowLimit).html(html);

            // Set value
            jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
          	
        }
    }
};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e);if(i!=this.selector.filterTree&&i!=this.selector.filterTreeHorizontal&&jQ(i).html(""),void 0===i)i="vertical"==t?this.selector.filterTree:this.selector.filterTreeHorizontal;void 0!==r&&"before"==r?jQ(i).prepend(e):jQ(i).append(e)};
/* End Fix version 2.3.2 */
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
